import { BaseError } from './BaseError';
import powerOff from 'assets/images/power-off.svg';

const errorLargeKey = 'error.internal_server_error.large_text';
const errorSmallKey = 'error.internal_server_error.small_text';

export const InternalServerError = () => (
    <BaseError
        iconUrl={powerOff}
        errorCode={500}
        keyLarge={errorLargeKey}
        keySmall={errorSmallKey}></BaseError>
);
